import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MessagesPageRoutingModule } from './messages-routing.module';

import { MessagesPage } from './messages.page';
import { TimeagoPipe } from 'src/app/timeago.pipe';
import { MsgparsePipe } from 'src/app/msgparse.pipe';
import { MessengerComponent } from 'src/app/components/messenger/messenger.component';
import { MessengerBotComponent } from 'src/app/components/messenger-bot/messenger-bot.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MessagesPageRoutingModule
  ],
  declarations: [MessagesPage, TimeagoPipe, MsgparsePipe, MessengerComponent, MessengerBotComponent]
})
export class MessagesPageModule {}
